import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/purchaseOrdersReportActions'
import ListItems from '../../../components/reports/general/purchase-orders/ListItems'
import { DatePicker, Button, Form, AutoComplete, Input, Icon, Spin } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item

class PurchaseOrdersReportContainer extends Component {
  constructor(props) {
    super(props)
    const filter = [
      moment(new Date(), 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]

    this.state = {
      filter: filter
    }

    // get job list
    this.props.purchaseOrdersReportGetJobList({})
    // get organization list
    this.props.purchaseOrdersReportGetCompaniesList()
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.purchaseOrdersReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.purchaseOrdersReportGetFullReport({ filters: values })
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/general/purchase-orders-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const jobListData = _.get(this.props, 'purchaseOrdersReportActions.jobList.data') || []
    const loadingJobList = _.get(this.props, 'purchaseOrdersReportActions.loadingJobList')

    const companiesListData =
      _.get(this.props, 'purchaseOrdersReportActions.companiesList.data') || []
    const loadingCompaniesList = _.get(
      this.props,
      'purchaseOrdersReportActions.loadingCompaniesList'
    )

    const loadingFullReport = _.get(this.props, 'purchaseOrdersReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'purchaseOrdersReportActions.fullReport.data')

    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Purchase Orders Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-12">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a value'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(jobListData)}
                          onSearch={this.handleJobSearch}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
                <div className="col-6">
                  <Spin spinning={loadingCompaniesList}>
                    <FormItem label="Vendor">
                      {getFieldDecorator('organization_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(companiesListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Vendor  "
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ purchaseOrdersReportActions, authentication }, ownProps) => ({
  purchaseOrdersReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

PurchaseOrdersReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(PurchaseOrdersReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/general/PurchaseOrdersReportContainer.js